import { render } from "./addactivity.vue?vue&type=template&id=128eb113&scoped=true&ts=true"
import script from "./addactivity.vue?vue&type=script&lang=ts"
export * from "./addactivity.vue?vue&type=script&lang=ts"

import "./addactivity.vue?vue&type=style&index=0&id=128eb113&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128eb113"]])

export default __exports__